const rules = {
	user: {
		static: [
			"ticket-options:transferWhatsapp",
		],
	},

	superv: {
		static: [
			"drawer-superv-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"ticket-options:transferWhatsapp"
		],
	},

	admin: {
		static: [
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
		],
	},

	userApi: {
		static: [
			"drawer-userApi-items:view",
		],
	},
};

export default rules;
